/**
 * Verifica se o usuário está autorizado a atuar como vendedor
 * (mesma regra do Cockpit / ranking).
 */
export function isUserAuthorizedSeller(user) {
  if (!user) return false

  const accessGroupName = String(user.access_group_name || '').trim()

  return (
    user.is_seller === true ||
    user.role === 'vendedor' ||
    user.role === 'Vendedor' ||
    accessGroupName === 'Vendedor' ||
    accessGroupName === 'vendedor'
  )
}
